import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class StockAdjustment extends BaseModel {
  fields = {
    'tanggal_penyesuaian': {
      label: 'Tanggal Penyesuaian',
      type: 'date',
      rules: 'required'
    },
    'jenis': {
      label: 'Jenis',
      type: 'enum',
      options: {
        'tambah': 'Tambah Stok',
        'kurang': 'Kurangi Stok'
      },
      rules: 'required'
    },
    'alasan': {
      label: 'Alasan',
      type: 'textarea',
      rules: 'required'
    }
  }

  endpoint = process.env.VUE_APP_API_URL + 'stock-adjustments'

  create (value) {
    const formData = this.initForEndpoint(value, true)
    if (value.approval_status) formData.append('approval_status', value.approval_status)
    Object.keys(value.details || {}).forEach((key, index) => {
      const detail = value.details[key]
      Object.keys(detail).forEach(field => {
        if (typeof detail[field] !== 'undefined' && detail[field] !== null) {
          if (detail[field] instanceof File) {
            formData.append('detail_barang[' + index + '][' + field + ']', detail[field], detail[field].name)
          } else {
            formData.append('detail_barang[' + index + '][' + field + ']', detail[field])
          }
        }
      })
    })
    return axios.post(this.endpoint, formData).then(response => response.data)
  }

  update (id, value) {
    const formData = this.initForEndpoint(value, true)
    Object.keys(value.details || {}).forEach((key, index) => {
      const detail = value.details[key]
      Object.keys(detail).forEach(field => {
        if (typeof detail[field] !== 'undefined' && detail[field] !== null) formData.append('detail_barang[' + index + '][' + field + ']', detail[field])
      })
    })
    formData.append('_method', 'PATCH')
    return axios.post(this.endpoint + '/' + id, formData).then(response => response.data)
  }

  approve (id) {
    return axios.patch(this.endpoint + '/' + id + '/approve').then(response => response.data)
  }

  returnForRevision (id, reason) {
    return axios.patch(this.endpoint + '/' + id + '/return', { returned_reason: reason }).then(response => response.data)
  }

  reject (id, reason) {
    return axios.patch(this.endpoint + '/' + id + '/reject', { rejected_reason: reason }).then(response => response.data)
  }

  submit (id) { return axios.patch(this.endpoint + '/' + id + '/submit').then(response => response.data) }

  barcodeStocks (id) { return axios.get(this.endpoint + '/' + id + '/barcodes').then(response => response.data) }
}
